import { useMutation } from "react-query"

import reservationsService from "api/reservationsService"

const useMarkReservationAsPrintedMutation = () => {
  return useMutation(async (reservationId: number) => {
    try {
      const res = await reservationsService.markReservationAsPrinted(
        reservationId,
      )

      return res.data
    } catch (err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useMarkReservationAsPrintedMutation
